import types from '../types';

const vote = (
  state = { loading: true, data: null, single: null, projectBalance: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_VOTE_PROJECTS_START:
    case types.GET_SINGLE_VOTE_PROJECT_START:
    case types.GET_PROJECT_BALANCE_START:
      return { ...state, single: null, projectBalance: null, loading: true };

    case types.GET_VOTE_PROJECTS_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_VOTE_PROJECTS_FAILURE:
    case types.GET_SINGLE_VOTE_PROJECT_FAILURE:
    case types.GET_PROJECT_BALANCE_FAILURE:
      return { ...state, loading: false };

    case types.GET_SINGLE_VOTE_PROJECT_SUCCESS:
      return { ...state, single: payload, loading: false };

    case types.DELETE_VOTE_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          votings: state.data.votings.filter(item => item.voting_id !== +payload),
        },
      };

    case types.PUT_VOTE_PROJECT_PUBLISHED_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          votings: state.data.votings.map(item =>
            item.voting_id === payload.voting_id
              ? { ...item, published: payload.published }
              : item,
          ),
        },
      };

    case types.GET_PROJECT_BALANCE_SUCCESS:
      return { ...state, projectBalance: payload, loading: false };

    default:
      return state;
  }
};

export default vote;
